import { connect } from 'react-redux'
import * as actions from '../../../state/actions/trips'
import TripServiceProductList from '../../../components/trips/services/TripServiceProductList'
import { actionCreators } from '../../../state/actions/trips/'
import * as serviceActions from '../../../state/actions/services'

import {
  createTrip,
  createWillCallTrip,
  createRecurringTrip,
  fetchIntegrationEta
} from '../../../state/actions/trips/index'
import {
  ITripEstimatesObject,
  ITripAvailableProduct,
  IStoreState,
  ITripExtraParams,
  SelectedAddOn,
  IRiderSearchObject
} from '../../../types'
import { withRouter } from 'react-router'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const products = ownProps.products
  const rider = state.riders.items[ownProps.riderId]
  let walletBalance = 0
  if (rider && rider.wallet) {
    walletBalance = (rider.wallet.wallet.balance + rider.wallet.wallet.bonusBalance) / 100
  }
  const selectedProductId = state.tripRequest.request.product.productId

  return {
    products,
    selectedProductId: selectedProductId && selectedProductId !== '' ? selectedProductId : null,
    walletBalance,
    tripRequest: state.tripRequest.request,
    currentServiceId: state.tripRequest.request.currentServiceId,
    fetching: state.tripRequest.metadata.fetching,
    bookDoubleTrip: state.tripRequest.request.bookDoubleTrip,
    willCall: state.tripRequest.request.willCall,
    pricingType: state.service.pricingType,
    rider,
    scheduledReturn: state.tripRequest.request.scheduledReturn,
    returnPickupTime: state.tripRequest.request.returnPickupTime
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateTripNotes: (notes: string) => dispatch(actions.actionCreators.updateTripNotes(notes)),
    updatePaymentMode: (paymentMode: string) => dispatch(actions.actionCreators.updatePaymentMode(paymentMode)),
    selectProduct: (product: ITripAvailableProduct) => dispatch(actionCreators.selectProduct(product)),
    setCurrentServiceId: (serviceId: string) => dispatch(actionCreators.setCurrentServiceId(serviceId)),
    selectEstimates: (estimates: ITripEstimatesObject) => dispatch(actionCreators.setEstimatesToTripRequest(estimates)),
    setTripDoubleCheckerEnable: (enable: boolean) => dispatch(actionCreators.setTripDoubleCheckerEnable(enable)),
    fetchIntegrationEta: (riderId: string, product: ITripAvailableProduct, addOn?: SelectedAddOn) => {
      return dispatch(fetchIntegrationEta(riderId, product, addOn))
    },
    createTrip: async (product: ITripAvailableProduct, params: ITripExtraParams) => {
      await dispatch(
        createTrip({
          addOnCost: params.addOnCost,
          addOnFare: params.addOnFare,
          addOn: params.addOn,
          scheduledReturn: params.scheduledReturn,
          returnPickupTime: params.returnPickupTime
        })
      )

      if (params.willCall) {
        await dispatch(
          createWillCallTrip({
            addOnCost: params.addOnCost,
            addOnFare: params.addOnFare,
            addOn: params.addOn,
            willCall: true
          })
        )
      }
    },
    createRecurringTrip: () => dispatch(createRecurringTrip()),
    fetchServicePricingType: (serviceId: string) => dispatch(serviceActions.fetchServicePricingType(serviceId)),
    setTripRequestTotalRidersFare: (totalRidersFare: number) =>
      dispatch(actions.actionCreators.setTripRequestTotalRidersFare(totalRidersFare)),
    updateRiderCount: (totalRider: number) => dispatch(actions.actionCreators.updateRiderCount(totalRider)),
    selectRider: (rider: IRiderSearchObject) => dispatch(actions.selectRider(rider)),
    createTripErrorMessage: (message: string) => dispatch(actionCreators.createTripErrorMessage(message))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TripServiceProductList)
)



// WEBPACK FOOTER //
// ./src/containers/trips/services/TripServiceProductList.ts